<template>
	<v-container fluid class="scroll-y fullscreen" pa-0>
		<v-card
			class="mx-auto"
			flat
			:loading="loading"
			loader-height="10"
			tile
			>
			<v-toolbar
				color="accent"
				dark
				flat
				>
				<v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
			</v-toolbar>
		</v-card>
		<v-card tile>
			<v-tabs
				v-model="tab"
				background-color="primary"
				dark
				center-active
				show-arrows
				fixed-tabs
				>
				<v-tab>Task Data</v-tab>
				<v-tab>Comments/Files</v-tab>
				<!--<v-tab></v-tab>-->
			</v-tabs>
			<v-tabs-items v-model="tab">
				<v-tab-item>
					<v-card flat tile color="accent">
						<v-card-text class="px-0 pt-0" style="padding-bottom: 60px;">
							<ValidationObserver ref="observer1">
								<v-form ref="personalform">
									<v-list flat color="accent" class="py-0">
										<v-list-item class="form-row">
											<v-list-item-content class="label">
												<v-list-item-title class="white--text font-weight-bold">Task Title</v-list-item-title>
											</v-list-item-content>
											<v-list-item-action>
												<ValidationProvider v-slot="{ errors }" name="Task Title" rules="required">
													<v-text-field
													v-model="form.title"
													:error-messages="errors"
													required
													solo
													flat
													dark
													></v-text-field>
												</ValidationProvider>
											</v-list-item-action>
										</v-list-item>
										<v-list-item class="form-row">
											<v-list-item-content class="label">
												<v-list-item-title class="white--text font-weight-bold">Details of the Task</v-list-item-title>
											</v-list-item-content>
											<v-list-item-action>
												<ValidationProvider v-slot="{ errors }" name="Details of the Task" rules="required">
													<vue-editor v-model="form.details" :error-messages="errors" required/>
												</ValidationProvider>
											</v-list-item-action>
										</v-list-item>
										<v-list-item class="form-row">
											<v-list-item-content class="label">
												<v-list-item-title class="white--text font-weight-bold">Resolution</v-list-item-title>
											</v-list-item-content>
											<v-list-item-action>
												<ValidationProvider name="Resolution">
													<vue-editor v-model="form.resolution"/>
												</ValidationProvider>
											</v-list-item-action>
										</v-list-item>
										<v-row
											no-gutters
											class="grid-items"
											>
											<v-col
												md="4"
												cols="12"
											>
												<v-list-item class="form-row">
													<v-list-item-content class="label">
														<v-list-item-title class="white--text font-weight-bold">Created At</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<v-text-field
															v-model="form.created_at"
															:error-messages="errors"
															required
															solo
															flat
															dark
															disabled
															></v-text-field>
													</v-list-item-action>
												</v-list-item>
											</v-col>
											<v-col
												md="4"
												cols="12"
											>
												<v-list-item class="form-row" v-if="form.user != null">
													<v-list-item-content class="label">
														<v-list-item-title class="white--text font-weight-bold">Created By</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<v-text-field
															v-model="form.user.name"
															:error-messages="errors"
															required
															solo
															flat
															dark
															disabled
															></v-text-field>
													</v-list-item-action>
												</v-list-item>
											</v-col>
											<v-col
												md="4"
												cols="12"
											>
												<v-list-item class="form-row">
													<v-list-item-content class="label">
														<v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<ValidationProvider v-slot="{ errors }" name="Category" rules="required">
															<v-autocomplete
																:items="systems"
																:error-messages="errors"
																v-model="form.system_id"
																color="white"
																item-text="title"
																item-value="id"
																placeholder="Category"
																required
																solo
																flat
																dark
																></v-autocomplete>
														</ValidationProvider>
													</v-list-item-action>
												</v-list-item>
											</v-col>
										</v-row>
										<v-row
											no-gutters
											class="grid-items"
											>
											<v-col
												md="6"
												cols="12"
											>
												<v-list-item class="form-row">
													<v-list-item-content class="label">
														<v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<ValidationProvider v-slot="{ errors }" name="Status" rules="required">
															<v-select
																:items="statuses"
																:error-messages="errors"
																v-model="form.status_id"
																color="white"
																item-text="title"
																item-value="id"
																placeholder="Status"
																required
																solo
																flat
																dark
																></v-select>
														</ValidationProvider>
													</v-list-item-action>
												</v-list-item>
											</v-col>
											<v-col
												md="6"
												cols="12"
											>
												<v-list-item class="form-row">
													<v-list-item-content class="label">
														<v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
															<v-autocomplete
																multiple
																:items="users"
																:error-messages="errors"
																v-model="form.assignee"
																color="white"
																item-text="name"
																item-value="id"
																placeholder="Assignee"
																required
																solo
																flat
																dark
															></v-autocomplete>
														</ValidationProvider>
													</v-list-item-action>
												</v-list-item>
											</v-col>
										</v-row>
									</v-list>
								</v-form>
							</ValidationObserver>
						</v-card-text>
						<v-card-actions class="fixed-actions">
							<v-btn large min-width="50%" color="primary"  @click="submit" :loading="loading" tile depressed>Update</v-btn>
							<v-btn large min-width="50%" color="white"  to="/tasks" text tile depressed>Cancel</v-btn>
						</v-card-actions>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<Comment v-for="(comment, index) in form.comments" :key="index" :item="comment"/>
					<v-divider></v-divider>
					<v-card flat tile class="comment-form" color="accent">
						<v-card-text>
							<v-form ref="commentform">
								<vue-editor v-model="comment.comment" ref="comment" />
							</v-form>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions class="admin-action">
							<v-spacer></v-spacer>
							<v-btn large min-width="100%" color="primary" tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
										<v-card flat tile color="accent">
						<v-card-text>
							<file-pond
								name="filepond"
								ref="filepond"
								label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
								v-bind:allow-multiple="true"
								:server="{
								url: 'https://tasks.bigcitymarketing.co/api/uploads/task?id='+id,
								process: {
								headers: {
								'Authorization': `Bearer ${token}`
								}
								},
								revert: {
								headers: {
								'Authorization': `Bearer ${token}`
								},
								}
								}"
								v-bind:files="files"
								v-on:init="handleFilePondInit"
								v-on:processfile="handleFilePondProcessfile"
								v-on:processfilerevert="handleFilePondRevertfile"/>
						</v-card-text>
					</v-card>
					<v-card flat tile class="mx-auto overflow-hidden">
						<v-data-table
							:headers="headers"
							:items="form.files"
							class="elevation-0"
							item-key="id"
							:loading="loading"
							>
							<template v-slot:item.actions="{ item }">
								<v-btn small depressed color="secondary" tile :href='`https://tasks.bigcitymarketing.co/storage/uploads/files/${item.file}`' target="_blank">
									<v-icon
										color="white"
										small
										>
										mdi-eye
									</v-icon>
								</v-btn>
								<v-btn small depressed color="primary" tile @click="deleteItem(item)">
									<v-icon
										small
										>
										mdi-delete
									</v-icon>
								</v-btn>
							</template>
							<template v-slot:item.file_name="props">
								<a :href="`https://tasks.bigcitymarketing.co/storage/uploads/files/${props.item.file}`" target="_blank">{{ props.item.file_name }}</a>
							</template>
							<template v-slot:item.user="props">
								{{ props.item.user.name }}
							</template>
						</v-data-table>
						<v-dialog v-model="dialogDelete" max-width="500px">
							<v-card color="red">
								<v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
								<v-card-actions class="red darken-4">
									<v-spacer></v-spacer>
									<v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
									<v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
									<v-spacer></v-spacer>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-card>
				</v-tab-item>
				<!--<v-tab-item>

				</v-tab-item>-->
			</v-tabs-items>
		</v-card>
	</v-container>
</template>
<script>
	import { mapGetters, mapActions } from 'vuex'
	import { required, email } from 'vee-validate/dist/rules'
	import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
	import axios from 'axios'
	import TokenService from '../../services/storage.service'
	import Comment from '../../components/Comment.vue'
	
	setInteractionMode('eager')
	
	extend('required', {
	    ...required,
	    message: '{_field_} can not be empty',
	})
	
	extend('email', {
	    ...email,
	    message: 'Please enter a valid email address',
	})
	
	export default {
	    props: ['id'],
	    data () {
	        return {
	            form: {
	                systemy_id: '',
					title: '',
	                details: '',
	                resolution: '',
	                status_id: 1,
	                user: [],
	                comments: [],
	                files: [],
					assignee: [],
	            },
	            yesno: [
	                { label: 'Yes', value: 1},
	                { label: 'No', value: 0}
	            ],
	            loading: false,
	            pageTitle: '',
	            voptions: {
	                toolbar: true,
	                url: 'data-source'
	            },
	            requiredValue: true,
	            files: [],
	            tab: 0,
	            comment: {
	                comment: '',
	            },
	            token: '',
	            headers: [
	                { text: 'File Name', value: 'file_name', sortable: false },
	                { text: 'Added By', value: 'user', sortable: false },
	                { text: 'Created At', value: 'created_at', sortable: false },
	                { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
	            ],
	            dialogDelete: false,
	            editedItem: {
	                id: '',
	            },
	            defaultItem: {
	                id: '',
	            },
	        }
	    },
	    created() {
	        this.pageTitle = this.$route.meta.title

			if (this.$route.query.tab === 'comments') {
				this.tab = 1
			} else {
				this.tab = 0
			}

	        this.getTask()
	        this.token = TokenService.getToken()
	    },
	    computed: {
	        ...mapGetters({
	            systems: 'data/systems',
	            statuses: 'data/task_status',
	            users: 'data/users',
	        }),
	    },
	    components: {
	        ValidationProvider,
	        ValidationObserver,
	        Comment
	    },
	    methods: {
	        ...mapActions({
	            updateTask: 'data/updateTask',
	            addComment: 'data/addTaskComment'
	        }),
	        getTask() {
	            if(this.id) {
	                this.loading = true
	                axios.get('tasks/' + this.id)
	                    .then((response) => {
	                        this.loading = false
	                        this.form = response.data
	                        this.$nextTick()
	                    }).catch((error) => {
	                        if(error.response.status === 401) {
	                            this.$store.commit('SET_SNACKTYPE', 'red')
	                            this.$store.commit('SET_SNACK', 'Sorry. You don\'t have suffient permission to view this page.')
	                            this.$router.push({ path: '/tasks' })
	                        } else {
	                            this.$router.push({ path: '/tasks' })
	                        }
	                    })
	            }
	        },
	        async submit() {
	            let valid1 = await this.$refs.observer1.validate()
	
	            if(valid1) {
	                this.loading = true
	                this.$set(this.form, 'id', this.id)
	                this.updateTask(this.form).then(() => {
	                    this.loading = false
	                    this.$store.commit('SET_SNACKTYPE', 'green')
	                    this.$store.commit('SET_SNACK', 'Successfully saved!')
	                    this.$router.push({ path: '/tasks' })
	                }).catch(() => {
	                    this.loading = false
	                    this.$store.commit('SET_SNACKTYPE', 'red')
	                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
	                })
	            } else {
	                this.$store.commit('SET_SNACKTYPE', 'red')
	                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
	            }
	        },
	        async sendComment() {
	            this.loading = true
	            this.addComment({
	                id: this.id, 
	                comment: this.comment.comment,
	            }).then(response => {
	                this.loading = false
	                this.form.comments.push(response)
	                this.comment.comment = ''
	                this.comment.parent = null
	                this.$store.commit('SET_SNACKTYPE', 'green')
	                this.$store.commit('SET_SNACK', 'Successfully saved')
	            }).catch(() => {

	                this.loading = false
	                this.$store.commit('SET_SNACKTYPE', 'red')
	                this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
	            })
	        },
	        handleFilePondProcessfile: function () {
	            this.getTask();
	            this.$nextTick()
	        },
	        handleFilePondRevertfile: function () {
	            this.getTask();
	            this.$nextTick()
	        },
	        deleteItem (item) {
	            this.editedItem = Object.assign({}, item)
	            this.dialogDelete = true
	        },
	        deleteItemConfirm () {
	            this.loading = true
	            axios.delete('uploads/task_by_id?id=' + this.editedItem.id)
	                .then(() => {
	                    this.closeDelete()
	                    this.getTask()
	                    this.$nextTick()
	                })
	        },
	        closeDelete () {
	            this.dialogDelete = false
	            this.$nextTick(() => {
	                this.editedItem = Object.assign({}, this.defaultItem)
	            })
	        },
	    }
	}
</script>

<style scoped>
.fixed-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100; /* make sure it's above other elements */
  background: inherit; /* or set a background color if needed */
  padding: 10px; /* adjust as needed */
}

/* Optional: Add bottom padding to the container that holds your form content */
.scroll-y {
  padding-bottom: 70px; /* adjust to match the height of your fixed actions */
}
</style>


<style lang="sass">
.v-list-item__content
    padding: 20px 0

.v-list-item
    @media (min-width: 992px)
        .v-list-item__content.label + .v-list-item__action
            width: 85%

.grid-items
    @media (min-width: 992px)
        .v-list-item__content.label + .v-list-item__action
            width: 77%
</style>
